import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedVideo: undefined,
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    seletedVideo: (state, action) => {
      state.selectedVideo = action.payload;
    },
  },
});

export const { seletedVideo } = videoSlice.actions;
export default videoSlice.reducer;
